import { Component } from "react"

class UserId extends Component{
    constructor(props){
        super(props)
        this.name = "ユーザ名"
    }
    validate(callbackDialog){
        if(String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if("/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i".test(this.props)){
            callbackDialog("エラー",this.name + "は36文字以内にしてください。")
            return false
        }
        return true
    }
}

export default UserId;